import XEUtils from 'xe-utils'
import Md5 from './md5'
import store from '../../store/index'
import router from '@/router/index'
import { MessageBox } from 'element-ui'
import http from '@/axios'

// 日期格式化
export function ykDateFormat(fmt, str) {
  if (!str) {
    return ''
  }
  var date = new Date(str)
  if (!date) {
    return ''
  }
  if (date.getFullYear() === 1900) {
    return ''
  } else {
    return XEUtils.toDateString(str, fmt)
  }
}

// table 移除空行
export function removeEmptyForTable(table, defaultArray = []) {
  let tableData = table.getTableData().fullData
  for (let row of tableData) {
    let ifRemove = true
    for (let key in row) {
      if (key !== '_XID' && !defaultArray.includes(key)) {
        if (row[key] !== null) {
          ifRemove = false
          break
        }
      }
    }
    if (ifRemove) {
      table.remove(row)
    }
  }
}

// 移除数组为null,''的属性
export function removeArrayNull(array) {
  for (let obj of array) {
    Object.keys(obj).forEach(item => {
      if (!obj[item]) {
        delete obj[item]
      }
    })
  }
  return array
}
// 移除对象为null,''的属性
export function removeObjectNull(obj) {
  let copy = JSON.parse(JSON.stringify(obj))
  Object.keys(copy).forEach(item => {
    if (!copy[item]) {
      delete copy[item]
    }
  })
  return copy
}

// 打开界面
export function openPush({ url, id, title = '相关菜单', msg, params }) {
  let menuArgs = ''
  let directory = ''
  let vueName = ''
  let ifCanOpen = false
  let path = `/${Md5.md5(url)}`
  let menu = JSON.parse(JSON.stringify(store.state.menulist))

  const dfs = n => {
    if (!n.children) return
    for (let item of n.children) {
      if (!item.children && '/' + item.md5Path === path) {
        // item.children 不存在, 意味着当前节点是叶子节点
        directory = item.directory
        vueName = item.pathDetail
        menuArgs = item.menuArgs
        title = item.name
        return true
      } else if (item.children?.length) {
        // 非叶子节点，继续深度遍历
        let result = dfs(item)
        if (result) {
          return result
        }
      }
    }
    return false
  }

  // menu: [{ children:[], key:'', name:''}, ..]
  for (let n of menu) {
    ifCanOpen = dfs(n)
    if (ifCanOpen) {
      break
    }
  }

  let message = msg === '' ? '是否跳转到对应界面？' : msg

  return new Promise(promiseResolve => {
    MessageBox.confirm(message, '提示', {
      distinguishCancelAndClose: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      new Promise(resolve => {
        if (ifCanOpen === false) {
          MessageBox.confirm(`您没有打开${title}的权限！`, '提示', {
            distinguishCancelAndClose: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
        }
        resolve(ifCanOpen)
      }).then(result => {
        if (result) {
          router.push({
            name: path,
            params: {
              directory: directory,
              vueName: vueName,
              menuArgs: menuArgs,
              id: id,
              ...params
            }
          })
          promiseResolve(true)
        }
      })
    })
  })
}

/**
 * 获取通用附件列表
 * @param {*} vuePath 页面
 * @param {*} id 单据标识
 * @returns 附件列表
 */
export async function getCommonAttachments(vuePath, id) {
  let attachmentList = []
  if (!vuePath || !id) {
    return
  }

  const { data: res } = await http.post('/Base/BAttachment/common', {
    vuePathName: vuePath,
    aKeyValue: id
  })

  if (res.isSuccess) {
    attachmentList = res.data
  } else {
    MessageBox({
      message: res.errorMessage,
      type: 'error',
      title: '提示'
    })
  }
  return attachmentList
}

/**
 * 删除通用附件
 * @param {*} id 附件标识
 * @returns 是否删除成功
 */
export async function removeAttachmentOne(id) {
  const { data: res } = await http.delete(`/Base/BAttachment/common/${id}`)
  return res
}

/**
 * 上传通用附件
 * @param {*} fileList 附件对象列表
 * fileList: [
    {
      "keyValue": 0,
      "fileName": "string",
      "display": "string",
      "fileClass": "string",
      "filePath": "string",
      "type": "string",
      "fileSize": "string",
      "byteSize": "string",
      "memo": "string"
    }
  ]
 * @returns 是否上传成功
 */
export async function uploadAttachments(fileList) {
  const { data: res } = await http.post('/Base/BAttachment/common-bulk-insert', fileList)
  return res.isSuccess
}

// 封装函数 - 高精度计算, 如果表达式错误的话返回0
export function calculate(expression) {
  // 定义运算符和它们对应的函数
  const operators = {
    '+': XEUtils.add,
    '-': XEUtils.subtract,
    '*': XEUtils.multiply,
    '/': XEUtils.divide,
    '&': XEUtils.round // 保留小数, 四舍五入
  }

  // 对后缀表达式进行求值
  function evaluate(tokens) {
    const stack = []

    while (tokens.length > 0) {
      const token = tokens.shift()

      // 如果是运算符，则从栈中取出两个数进行计算，结果再放回栈中
      if (token in operators) {
        const b = stack.pop()
        const a = stack.pop()
        stack.push(operators[token](a, b))
      } else {
        // 如果是数字，则直接放入栈中
        stack.push(parseFloat(token))
      }
    }

    // 栈中剩下的最后一个元素就是表达式的结果
    return stack.pop()
  }

  // 将表达式解析为标记列表
  function parse(expression) {
    let tokens = []
    let number = ''

    for (let i = 0; i < expression.length; i++) {
      const char = expression[i]

      // 如果是运算符或括号，则将前面的数字和当前的字符都加入到标记列表中
      if (char in operators || char === '(' || char === ')') {
        if (number !== '') {
          tokens.push(number)
          number = ''
        }

        tokens.push(char)
      } else {
        // 如果是数字，则添加到当前的数字字符串中
        number += char
      }
    }

    // 如果最后还剩下一个数字，则也加入到标记列表中
    if (number !== '') {
      tokens.push(number)
    }

    return tokens
  }

  // 将中缀表达式转换为后缀表达式
  function infixToPostfix(tokens) {
    const outputQueue = []
    const operatorStack = []
    // 定义运算符的优先级
    const precedence = {
      '+': 1,
      '-': 1,
      '*': 2,
      '/': 2,
      '&': 3
    }

    while (tokens.length > 0) {
      const token = tokens.shift()

      if (token in operators) {
        // 如果栈顶的运算符优先级大于等于当前运算符，则将栈顶的运算符放入到输出队列中
        while (operatorStack.length > 0 && precedence[operatorStack[operatorStack.length - 1]] >= precedence[token]) {
          outputQueue.push(operatorStack.pop())
        }

        // 将当前运算符放入到栈中
        operatorStack.push(token)
      } else if (token === '(') {
        // 如果是左括号，则直接放入到栈中
        operatorStack.push(token)
      } else if (token === ')') {
        // 如果是右括号，则将栈顶的运算符放入到输出队列中，直到遇到左括号
        while (operatorStack.length > 0 && operatorStack[operatorStack.length - 1] !== '(') {
          outputQueue.push(operatorStack.pop())
        }

        // 弹出左括号
        operatorStack.pop()
      } else {
        // 如果是数字，则直接放入到输出队列中
        outputQueue.push(token)
      }
    }

    // 如果栈中还剩下运算符，则依次放入到输出队列中
    while (operatorStack.length > 0) {
      outputQueue.push(operatorStack.pop())
    }

    return outputQueue
  }

  try {
    // 去除空格并解析为标记列表
    const tokens = parse(expression.replace(/\s+/g, ''))
    // 将标记列表转换为后缀表达式
    const postfixTokens = infixToPostfix(tokens)
    // 对后缀表达式进行求值
    const result = evaluate(postfixTokens)
    // 如果结果是 NaN，则返回 0
    return isNaN(result) ? 0 : result
  } catch (error) {
    // 捕获并处理可能出现的错误
    console.error('Invalid expression:', expression)
    return 0
  }
}
